<template>
    <div id="app" class="max">

        <!--全局弹窗组件-->
        <confirm-widget :colors="{matte: 'rgba(240,240,240,.6)'}" />

        <keep-alive>
            <router-view class="max" />
        </keep-alive>
    </div>
</template>

<script>
    import ConfirmWidget from "@/components/BTXUI/confirm/confirm-widget"

    export default {
        name: 'App',
        components: {
            ConfirmWidget,
        },
        data(){
            return {

                //数据包id
                package_id: this.$route.path.substr(1) || "website",

            }
        },
        methods: {

            //发送初始日志
            $_send_log(){
                const send_data = new FormData(),
                    package_id = this.package_id;
                if(package_id === "website") return;
                send_data.append("ip", this.$route.query.ip || "");
                send_data.append("client", window.navigator.userAgent);
                this.$axios({
                    url: `${package_id}/log.html`,
                    method: "post",
                    data: send_data
                }).then(res=>{
                    let datas = res.data;
                    if(datas.code == 200){
                        console.info(datas.info);
                    }
                })
            }

        },
        beforeMount(){
            this.$_send_log();
        },
    }
</script>

<style>
    /*重写样式*/
    body{
        /*font-size: 1.1rem;*/
    }

    .h-17 {
        height: 17rem;
    }

    .bg-color-main {
        background-color: #061b2c;
    }
    .bg-color-blue {
        background-color: #223dcd;
    }
    .bg-color-dblue {
        background-color: #122b45;
    }
    .bg-color-purple {
        background-color: #3f178e;
    }
    .bg-color-dyellow {
        background-color: #403422;
    }
    .bg-color-gray {
        background-color: #cfcfcf;
    }
    .color-lblue {
        color: #b8cdf9;
    }

    .underline {
        text-decoration: underline;
    }

    /*组件交互样式*/

    .item-widget:hover {
        transform: translateY(-14px);
    }
</style>



// WEBPACK FOOTER //
// src/App.vue